import React from "react";
import styled, { css } from "styled-components";
import { Row, Col } from "components/bootstrap";
const StyledListItem = styled.li(
  ({ theme }) => css`
    display: block;
    padding: 15px 0;

    h2 {
      font-family: ${theme.fonts.family.body};
    }

    h2 .label {
      margin-left: 5px;
      line-height: 1;
      vertical-align: baseline;
    }

    .item-description {
      min-height: 17px;
      margin: 5px 0;
    }

    .item-actions > .btn,
    .item-actions > .btn-group,
    .item-actions > span > .btn {
      margin-left: 5px;
      margin-bottom: 5px;
    }

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.gray[90]};
    }
  `
);
const EntityListItem = ({
  actions = void 0,
  contentRow = void 0,
  description = void 0,
  title,
  titleSuffix = void 0
}) => {
  const wrappedTitleSuffix = titleSuffix ? /* @__PURE__ */ React.createElement("small", null, titleSuffix) : null;
  const actionsContainer = /* @__PURE__ */ React.createElement("div", { className: "item-actions text-right" }, actions);
  return /* @__PURE__ */ React.createElement(StyledListItem, null, /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("div", { className: "pull-right hidden-xs" }, actionsContainer), /* @__PURE__ */ React.createElement("h2", null, title, " ", wrappedTitleSuffix), description && /* @__PURE__ */ React.createElement("div", { className: "item-description" }, /* @__PURE__ */ React.createElement("span", null, description))), /* @__PURE__ */ React.createElement(Col, { sm: 12, lgHidden: true, mdHidden: true, smHidden: true }, actionsContainer)), contentRow && /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, contentRow));
};
export default EntityListItem;
